import * as React from 'react';
import Common from '../utilities/common';
import $ from "jquery";
import { Card, CardContent, Stack, Typography } from '@mui/material';
import FunctionsOutlinedIcon from '@mui/icons-material/FunctionsOutlined';
import ReactInterval from 'react-interval';

export interface IDataSummaryTotalProps {
    title: string;
    field: string;
    icon?: string | JSX.Element | JSX.Element[];
}

export interface IDataSummaryTotalState {
    total: number;
}

export default class DataSummaryTotal extends React.Component<IDataSummaryTotalProps, IDataSummaryTotalState> {
    public constructor(props: IDataSummaryTotalProps) {
        super(props);

        this.state = {
            total: 0
        }
    }

    componentDidMount(): void {
        this.Get();
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                <Card>
                    <CardContent>
                        {
                            this.props.icon == null && (
                                <React.Fragment>
                                    <Typography gutterBottom variant="body2" color='text.secondary' component="div">
                                    {
                                        this.props.title
                                    }
                                    </Typography>
                                    {
                                        this.state.total > -1 && (
                                            <Typography variant='h5' color="text.secondary" gutterBottom textAlign='center'>
                                                {
                                                    this.state.total.toLocaleString()
                                                }
                                            </Typography>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                        {
                            this.props.icon != null && (
                                <React.Fragment>
                                    <Typography gutterBottom variant="body2" color='text.secondary' component="div">
                                    {
                                        this.props.title
                                    }
                                    </Typography>
                                    <Stack direction='row' spacing={1} justifyContent={'flex-start'}>
                                    {
                                        this.props.icon
                                    }
                                    {
                                        this.state.total > -1 && (
                                            <Typography variant='h5' color="text.secondary" textAlign='center'>
                                                {
                                                    this.state.total.toLocaleString()
                                                }
                                            </Typography>
                                        )
                                    }
                                    </Stack>
                                </React.Fragment>
                            )
                        }
                    </CardContent>
                </Card>
            </React.Fragment>
        )
    }

    private Get() {
        let url = `${Common.END_POINT}/data/total`;


        if(!Common.IsNullOrEmpty(this.props.field)) {
            url += `/${this.props.field}`
        }
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: number) => {
            let current = 0;

            if (response > 100) {
                current = response - Math.round(response / 10)
            }

            if (response > 1000) {
                current = response - Math.round(response / 100);
            }

            this.setState(
                {
                    total: response
                }
            );
        })
    }
}